const textFieldModalEquipServQuest = {
  name: 'Question',
  description: 'Question Detail *',
  helperText: '* The purpose of this field is to help the executor to answer this question correctly'
};

export default textFieldModalEquipServQuest;
